import React from 'react';

const About = () => {
    return (
        <div>
            <h1>
                About This App
            </h1>
            <p> Single Page React App to search Github users</p>
            <p> Version:1.0.0 </p>
            <p> Created by Daniel Badura </p>
            <p> Based on Brad Traversy: React Front To Back </p>
        </div>
    )
}
export default About;